export default __webpack_public_path__ + "beb7d9c000ed0dd4d81d0b7372960d45.png";